import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import './ImageSlider.css';

export default observer(({ slides }) => {
  const [current, setCurrent] = useState(0);
  const length = slides.length;

  const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  if (!Array.isArray(slides) || slides.length <= 0) {
    return null;
  }

  return (
    <section className='slider'>
      <ArrowLeftIcon className='left-arrow' onClick={prevSlide} fontSize={'large'} />
      <ArrowRightIcon className='right-arrow' onClick={nextSlide} fontSize={'large'}/>
      {slides.map((slide, index) => {
        return (
          <div
            className={index === current ? 'slide active' : 'slide'}
            key={index}
          >
            {index === current && (
              <a href={slide.promotionLink} target='_blank' rel='noreferrer noopener'>
              <img src={slide.pictureLink} alt='travel image' className='sliderImage' />
              </a>
            )}
          </div>
        );
      })}
    </section>
  );
});
